import type { IconData } from '@stacksjs/iconify-core'

export const lc1x1: IconData = {
  "body": "<g fill-rule=\"evenodd\"><path fill=\"#65cfff\" d=\"M0 0h512v512H0z\"/><path fill=\"#fff\" d=\"m254.8 44.8l173.5 421.6l-344 1L254.7 44.8z\"/><path fill=\"#000001\" d=\"m255 103l150 362.6l-297.5.8z\"/><path fill=\"#ffce00\" d=\"m254.8 256.1l173.5 210.8l-344 .5z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default lc1x1
